import React from 'react';
import { Toolbar } from 'features/command-center';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import DataTable from 'UI/components/organisms/DataTable';
import { Endpoints } from 'UI/constants/endpoints';

import {
  ACTIVITY_LOGS_COLUMNS,
  COPIES,
  ORDER_BY_OPTIONS,
  PAGE_KEY
} from './SendoutActivityLogsTabContent.constants';

const initialPreferences = getColumnPreferences(
  PAGE_KEY,
  0,
  ORDER_BY_OPTIONS,
  ACTIVITY_LOGS_COLUMNS,
  0
);

const getEmptyStateCopies = ({ hasSearchText }) => {
  if (hasSearchText) return COPIES.searchEmptyState;
  return COPIES.emptyState;
};

export const SendoutActivityLogsTabContent = ({ sendoutId }) => {
  const endpoint = `${Endpoints.SendoutsLogs.replace(':id', sendoutId)}`;

  const {
    columnPreferences,
    count,
    data,
    handleColumnDisplayChange,
    handleColumnOrderChange,
    handleColumnSortChange,
    handleFiltersToggle,
    handleKeywordChange,
    handlePageChange,
    handlePerPageChange,
    listState
  } = useDatatable({
    apiVersion: 2,
    columnsDefinitions: ACTIVITY_LOGS_COLUMNS,
    endpoint,

    initialPreferences,
    key: PAGE_KEY,
    orderByOptions: ORDER_BY_OPTIONS,
    shouldScrollOnNavigate: true,
    shouldUseSavedPagination: false
  });

  const { isLoading, showWholeSkeleton, page, perPage, keyword } = listState;
  const { columns, columnOrder, orderBy, direction } = columnPreferences;

  const finalColumns = getColumnsToRender(columns);
  const hasSearchText = Boolean(keyword && keyword.trim());
  const emptyStateCopies = getEmptyStateCopies({ hasSearchText });

  return (
    <DataTable
      columnOrder={columnOrder?.length ? columnOrder : undefined}
      columns={finalColumns}
      components={{ TableToolbar: Toolbar }}
      count={count ?? 0}
      data={data}
      draggableColumns={{ enabled: true }}
      elevation={0}
      filter={false}
      loading={showWholeSkeleton}
      onColumnDisplayClick={handleColumnDisplayChange}
      onColumnOrderChange={handleColumnOrderChange}
      onColumnSortChange={handleColumnSortChange}
      onPageClick={handlePageChange}
      onPerPageClick={handlePerPageChange}
      onSearchTextChange={handleKeywordChange}
      onToggleFilters={handleFiltersToggle}
      page={page}
      refreshing={isLoading}
      rowsPerPage={perPage}
      searchText={keyword}
      selectToolbarPlacement="none"
      selectableRows="none"
      sortOrder={{ name: orderBy, direction }}
      subtitle={emptyStateCopies.subtitle}
      title={emptyStateCopies.title}
    />
  );
};
